import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import $ from "jquery";
import styles from "./Main.module.css";
import {
  ExclamationCircleFilled,
  DeleteOutlined,
  QuestionOutlined,
  FormOutlined,
} from "@ant-design/icons";

import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Popover,
  Radio,
  Row,
  Select,
  Table,
  notification,
} from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  AuthKeys,
  checkCloseNumFn,
  checkEmpty,
  clearToken,
  focusNextElement,
  getAboteOpen,
  getAboteOpenUtil,
  getAboutLot,
  getCheckPrevent,
  getCheckPreventV2,
  getCurrentDateUtil,
  getCurrentDateUtilYYYY,
  getLot,
  getLotCloses,
  getLotClosesDate,
  getPrevent,
  getPreventLot,
  getPreventNumbersDate,
  getTextType,
  getToken,
  indexMore,
  logoutApi,
  numberWithCommas,
  parseJwt,
  pathRoutes,
  reverseString19,
  reverseString2,
  reverseString3,
  saveBilApi,
  savePostUtilApi,
  subStringText,
  subStringTextWin,
} from "../service/util.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import CardLot from "../card/CardLot";
import Countdown from "react-countdown";
import LoadingCenterSpinSmalljs from "./LoadingCenterSpinSmall";
import LoadingCenterSpinSmall from "./LoadingCenterSpinSmall";
import { type } from "@testing-library/user-event/dist/type";
import LotTableFnPage from "../lotTable/LotTableFnPage";
import { HexColorPicker } from "react-colorful";
import LoadingCenterSpinSmallBlue from "./LoadingCenterSpinSmallBlue";
const { confirm } = Modal;

const lotTypes = [
  {
    key: "lot_2",
    name: "2 ตัว",
    text1: "+ เลขเบิ้ล",
    text2: "บน",
    text3: "ล่าง",
  },
  {
    key: "lot_3",
    name: "3 ตัว",
    text1: "+ เลขตอง",
    text2: "บน",
    text3: "โต๊ด",
  },
  { key: "lot_6", name: "6 กลับ" },
  { key: "lot_19", name: "19 ประตู", text1: "บน", text2: "ล่าง" },
  { key: "lot_run", name: "วิ่งเลข", text1: "วิ่งบน", text2: "วิ่งล่าง" },
  { key: "lot_win", name: "เลขวิน" },
];

function MainS1(props) {
  return (
    <>
      <MenuLett />
      <div className={styles.boxMain}>
        <MenuTop />
        <Content />
      </div>
    </>
  );
}

const defaultColor = "rgb(255, 237, 183)";

function Content(props) {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [lot, setLot] = useState({});
  const [lotActive, setLotActive] = useState(lotTypes[0]);
  const [winType1, setWinType1] = useState("win_2");
  const [winType2, setWinType2] = useState("win_not_double");
  const [winNumbers, setWinNumbers] = useState([]);
  const [numLot, setNumLot] = useState([]);
  const [numLotError, setNumLotError] = useState([]);
  const [numLotErrorBil, setNumLotErrorBil] = useState([]);
  const [currentBil, setcurrentBil] = useState({});
  const [value_2_3, setValue_2_3] = useState("");
  const [value_6, setValue_6] = useState("");
  const [value_19, setValue_19] = useState("");
  const [value_19_nums, setValue_19_nums] = useState([]);
  const [value_6_nums, setValue_6_nums] = useState([]);
  const [value_win, setValue_win] = useState("");
  const [remark, setRemark] = useState("");
  const [lotBils, setLotBils] = useState([]);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [topPriceMain, setTopPriceMain] = useState("");
  const [winNumber, setWinNumber] = useState("");
  const [bottomPriceMain, setBottomPriceMain] = useState("");
  const [totPriceMain, setTotPriceMain] = useState("");
  const [open, setOpen] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);
  const [lotDate, setLotDate] = useState(getCurrentDateUtilYYYY());
  const [confirmnextModal, setConfirmnextModal] = useState(false);
  const [confirmnextModalClose, setConfirmnextModalClose] = useState(false);
  const [numLotErrorBilClose, setNumLotErrorBilClose] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [bgColor, setBgColor] = useState(defaultColor);
  const [bgColorTemp, setBgColorTemp] = useState(defaultColor);

  const [lotPrevent, setLotPrevent] = useState([]);
  const [lotPreventLot, setLotPreventLot] = useState([]);

  const [lotClosees, setLotClosees] = useState([]);
  const [lotClosees3, setLotClosees3] = useState([]);
  const [lotClosees2, setLotClosees2] = useState([]);
  const [lotActive52, setLotActive52] = useState("52");
  const [lotActive52List, setLotActive52List] = useState([]);

  const value_2_3_ref = useRef(null);
  const value_6_ref = useRef(null);
  const value_19_ref = useRef(null);
  const value_win_ref = useRef(null);

  const value_top_23_ref = useRef(null);
  const value_bt_23_ref = useRef(null);
  const btn_add_23_ref = useRef(null);

  const value_top_6_ref = useRef(null);
  const btn_add_6_ref = useRef(null);

  const value_top_19_ref = useRef(null);
  const value_bt_19_ref = useRef(null);
  const btn_add_19_ref = useRef(null);

  const value_top_run_ref = useRef(null);
  const value_bt_run_ref = useRef(null);
  const btn_add_run_ref = useRef(null);

  const value_top_win_ref = useRef(null);
  const value_bt_win_ref = useRef(null);
  const btn_add_win_ref = useRef(null);
  const btn_cal_win_ref = useRef(null);

  const [totalNumsLot2More, setTotalNumsLot2More] = useState(false);

  useEffect(() => {
    let user = parseJwt(getToken());
    console.log("user : ", user);
    setUserInfo(user);
    let bgcolor = localStorage.getItem(AuthKeys.cardBgColor);
    if (!checkEmpty(bgcolor)) {
      setBgColor(bgcolor);
      setBgColorTemp(bgcolor);
    }

    let aboutLot = JSON.parse(localStorage.getItem("aboutLot"));
    let lots = [];
    for (let a = 0; a < aboutLot?.lots?.length; a++) {
      let text = `[${aboutLot?.lots[a]?.lot_type}] ${aboutLot?.lots[a]?.lot_name}`;
      let lot = { value: aboutLot?.lots[a]?.lot_id, label: text };
      lots.push(lot);
    }
    setLotActive52List(Object.assign([], lots));
  }, []);

  const loadDataprevent = async () => {
    let lot_id = searchParams.get("lot_id");
    try {
      let data = await getPreventLot(lot_id);
      setLotPreventLot(data);
    } catch (e) {}
  };

  useEffect(() => {
    loadDataprevent();
  }, []);

  const loadData = async () => {
    let lot_id = searchParams.get("lot_id");
    // console.log("lot_id:", lot_id);
    if (checkEmpty(lot_id)) {
      navigate(pathRoutes.main);
    } else {
      try {
        let lotDetail = await getLot(lot_id);
        setLot(lotDetail);
        reflectorLotPrevent(lotDetail.prevent_numbers);
      } catch (e) {}
    }
  };

  const loadLotClose = async (lotDate) => {
    let lot_id = searchParams.get("lot_id");
    try {
      let lotCloses = await getLotClosesDate(lot_id, lotDate);
      setLotClosees(lotCloses);
      setLotClosees3(
        lotCloses.filter((close) => close.close_number_type == "lot_3")
      );
      setLotClosees2(
        lotCloses.filter((close) => close.close_number_type == "lot_2")
      );
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    loadLotClose(lotDate);
  }, [lotDate]);

  useEffect(() => {
    loadData();
  }, []);
  const currentLotDate = useMemo(() => {
    // return getCurrentDateUtil();

    let res = getAboteOpenUtil(lot);

    let text = "";
    if (!checkEmpty(res.textNext)) text = " " + res.textNext;
    // setLotDateStr(res.textNext);
    setLotDate(res.lot_date);
    return res.lot_date + text;
  }, [lot]);

  const classWinNum = useMemo(() => {
    return getCurrentDateUtil();
  }, [winNumbers]);

  const addWinNums = (num) => {
    let nums = winNumbers;
    if (nums.length >= 7) return;
    let index = nums.findIndex((n) => n == num);
    if (index == -1) {
      nums.push(num);
    } else {
      nums.splice(index, 1);
    }
    console.log("nums", nums);
    setWinNumbers(Object.assign([], nums));
  };

  const setLot_2_3 = (e) => {
    // console.log("key", e);
    if (e.key == "Tab") {
      e.preventDefault();
      value_top_23_ref.current.focus();
      return;
    } else if (e.key == "Enter") {
      value_top_23_ref.current.focus();
      return;
    } else if (e.code == "Space") {
      setLot_2_3_advance("return");
      return;
    }
    console.log("setLot_2_3", e);
    let value = e.target.value;
    setValue_2_3(value);
    let checkuse = 2;
    if (lotActive.key === "lot_2") {
      checkuse = 2;
    } else if (lotActive.key === "lot_3") {
      checkuse = 3;
    }

    if (value.length < checkuse) {
      return;
    }

    let values = [];
    let already = false;
    let subStrOb = subStringText(already, values, value);
    already = subStrOb.already;
    values = subStrOb.values;

    if (!already) {
      let check = 0;
      let num = "";
      for (let a = 0; a < value.length; a++) {
        // if(isNaN(parseInt(value[a]))) continue;
        num = num + value[a];
        check++;
        if (check === checkuse) {
          check = 0;
          values.push(num);
        }
      }
    }
    let values2 = [];
    let valuesErrorFound = [];
    for (let a = 0; a < values.length; a++) {
      console.log("values[a]:", values[a]);
      if (
        checkEmpty(values[a]) ||
        (checkEmpty(values[a]) && checkEmpty(values[a].trim()))
      )
        continue;
      if (
        values[a].indexOf("+") != -1 ||
        values[a].indexOf("x") != -1 ||
        values[a].indexOf("*") != -1
      ) {
        valuesErrorFound.push(values[a].trim());
        continue;
      }
      if (!checkEmpty(values[a]) && values[a].trim().length == checkuse) {
        values2.push(values[a].trim());
      }
    }

    let valuesFinal = numLot;
    valuesFinal = valuesFinal.concat(values2);
    let valueTemps = valuesFinal;

    setNumLot(Object.assign([], valueTemps));
    setNumLotError(valuesErrorFound);
    setValue_2_3("");
  };

  const setLot_6 = (e) => {
    if (e.key == "Tab") {
      e.preventDefault();
      value_top_6_ref.current.focus();
      return;
    } else if (e.key == "Enter") {
      value_top_6_ref.current.focus();
      return;
    }
    // console.log("setLot_6", e);
    let value = e.target.value;
    setValue_6(value);
    let checkuse = 3;
    if (value.length < checkuse) {
      return;
    }

    let values = [];
    let already = false;
    let subStrOb = subStringText(already, values, value);
    already = subStrOb.already;
    values = subStrOb.values;

    if (!already) {
      let check = 0;
      let num = "";
      for (let a = 0; a < value.length; a++) {
        // if(isNaN(parseInt(value[a]))) continue;
        num = num + value[a];
        check++;
        if (check === checkuse) {
          check = 0;
          values.push(num);
        }
      }
    }
    let values2 = [];
    // console.log("values", values);
    let valuesErrorFound = [];
    for (let a = 0; a < values.length; a++) {
      if (
        checkEmpty(values[a]) ||
        (checkEmpty(values[a]) && checkEmpty(values[a].trim()))
      )
        continue;
      if (
        values[a].indexOf("+") != -1 ||
        values[a].indexOf("x") != -1 ||
        values[a].indexOf("*") != -1
      ) {
        valuesErrorFound.push(values[a]);
        continue;
      }
      if (!checkEmpty(values[a]) && values[a].trim().length == checkuse) {
        values2.push(values[a].trim());
      }
    }
    // console.log("values2", values2);
    let values3 = Object.assign([], values2);
    for (let a = 0; a < values2.length; a++) {
      let n = values2[a];
      values3 = values3.concat(reverseString3(n));
    }

    let valuesFinal = numLot;
    valuesFinal = valuesFinal.concat(values3);
    // let valueTemps = valuesFinal;
    let valueTemps = valuesFinal.filter((element, index) => {
      return valuesFinal.indexOf(element) === index;
    });

    setNumLot(Object.assign([], valueTemps));
    setValue_6("");
  };

  const setWinNumberCal = (e) => {
    /*
    let value = e.target.value;
    setWinNumber(value);
    let checkuse = 1;
    if (value.length < checkuse) {
      return;
    }

    let values = [];
    let already = false;
    let value_6_nums_t = value_6_nums;
    value_6_nums_t.push(value);
    setValue_6_nums(Object.assign([], value_6_nums_t));
    let vs = [];
    for (let z = 0; z < value_6_nums_t.length; z++) {
      let v = value_6_nums_t[z];
      let subStrOb = subStringText(already, values, v);
      already = subStrOb.already;
      values = subStrOb.values;

      if (!already) {
        let check = 0;
        let num = "";
        for (let a = 0; a < value.length; a++) {
          // if(isNaN(parseInt(value[a]))) continue;
          num = num + value[a];
          check++;
          if (check === checkuse) {
            check = 0;
            values.push(num);
          }
        }
      }
      let values2 = [];
      for (let a = 0; a < values.length; a++) {
        if ((parseInt(values[a]) + "").length == checkuse) {
          values2.push(values[a]);
        }
      }
      let values3 = Object.assign([], values2);

      let checkuseReal = 1;
      let values4 = [];
      for (let a = 0; a < values3.length; a++) {
        if ((values3[a] + "").length == checkuseReal) {
          values4.push(values3[a]);
        }
      }

      let valuesFinal = winNumbers;
      valuesFinal = valuesFinal.concat(values4);
      let valueTemps = valuesFinal;
      valueTemps = valueTemps.slice(0, 7);
      vs = vs.concat(valueTemps);
    }
    setWinNumbers(Object.assign([], vs));
    setWinNumber("");
    */

    let value = e.target.value;
    setWinNumber(value);

    let checkuse = 1;
    if (value.indexOf("*") != -1 || value.length < checkuse) {
      return;
    }

    let values = [];
    let already = false;
    let subStrOb = subStringTextWin(already, values, value);
    already = subStrOb.already;
    values = subStrOb.values;

    if (!already) {
      let check = 0;
      let num = "";
      for (let a = 0; a < value.length; a++) {
        // if(isNaN(parseInt(value[a]))) continue;
        num = num + value[a];
        check++;
        // if (check === checkuse) {
        check = 0;
        values.push(num);
        // }
      }
    }
    let values2 = [];
    for (let a = 0; a < values.length; a++) {
      if ((parseInt(values[a]) + "").length == checkuse) {
        values2.push(values[a]);
      }
    }

    let values3 = Object.assign([], values2);

    let checkuseReal = 1;
    let values4 = [];
    for (let a = 0; a < values3.length; a++) {
      if ((values3[a] + "").length == checkuseReal) {
        values4.push(values3[a]);
      }
    }

    let valuesFinal = winNumbers;
    valuesFinal = valuesFinal.concat(values4);
    // let valueTemps = valuesFinal.filter((element, index) => {
    //   return valuesFinal.indexOf(element) === index;
    // });
    let valueTemps = valuesFinal;
    valueTemps = valueTemps.slice(0, 7);
    setWinNumbers(Object.assign([], valueTemps));
    setWinNumber("");
  };

  const setLot_19 = (e) => {
    if (e.key == "Tab") {
      e.preventDefault();
      value_top_19_ref.current.focus();
      return;
    } else if (e.key == "Enter") {
      value_top_19_ref.current.focus();
      return;
    }
    // console.log("setLot_19", e);
    let value = e.target.value;
    setValue_19(value);
    let checkuse = 1;
    if (value.length < checkuse) {
      return;
    }
    let value_19_nums_t = value_19_nums;
    value_19_nums_t.push(value);
    setValue_19_nums(Object.assign([], value_19_nums_t));
    let vs = [];
    // console.log("value_19_nums_t", value_19_nums_t);
    for (let z = 0; z < value_19_nums_t.length; z++) {
      let v = value_19_nums_t[z];

      let values = [];
      let already = false;
      let subStrOb = subStringText(already, values, v);
      already = subStrOb.already;
      values = subStrOb.values;

      if (!already) {
        let check = 0;
        let num = "";
        for (let a = 0; a < v.length; a++) {
          // if(isNaN(parseInt(value[a]))) continue;
          num = num + v[a];
          check++;
          if (check === checkuse) {
            check = 0;
            values.push(num);
          }
        }
      }
      let values2 = [];
      let valuesErrorFound = [];
      for (let a = 0; a < values.length; a++) {
        if (
          checkEmpty(values[a]) ||
          (checkEmpty(values[a]) && checkEmpty(values[a].trim()))
        )
          continue;
        if (
          values[a].indexOf("+") != -1 ||
          values[a].indexOf("x") != -1 ||
          values[a].indexOf("*") != -1
        ) {
          valuesErrorFound.push(values[a]);
          continue;
        }
        if (!checkEmpty(values[a]) && values[a].trim().length == checkuse) {
          values2.push(values[a].trim());
        }
      }
      let values3 = Object.assign([], values2);
      for (let a = 0; a < values2.length; a++) {
        let n = values2[a];
        values3 = values3.concat(reverseString19(n));
      }
      let checkuseReal = 2;
      let values4 = [];
      for (let a = 0; a < values3.length; a++) {
        if ((values3[a] + "").length == checkuseReal) {
          values4.push(values3[a]);
        }
      }

      let valuesFinal = [];
      valuesFinal = valuesFinal.concat(values4);
      let valueTemps = valuesFinal.filter((element, index) => {
        return valuesFinal.indexOf(element) === index;
      });
      // let valueTemps = valuesFinal;
      // console.log("valueTemps",valueTemps)
      vs = vs.concat(valueTemps);
    }

    setNumLot(Object.assign([], vs));
    // setNumLotError(valuesErrorFound);
    setValue_19("");
  };

  const setLot_win = (e) => {
    if (e.key == "Tab") {
      e.preventDefault();
      value_top_run_ref.current.focus();
      return;
    } else if (e.key == "Enter") {
      value_top_run_ref.current.focus();
      return;
    }
    // console.log("setLot_win", e);
    let value = e.target.value;
    setValue_win(value);
    let checkuse = 1;
    if (value.length < checkuse) {
      return;
    }

    let values = [];
    let already = false;
    let subStrOb = subStringText(already, values, value);
    already = subStrOb.already;
    values = subStrOb.values;

    if (!already) {
      let check = 0;
      let num = "";
      for (let a = 0; a < value.length; a++) {
        // if(isNaN(parseInt(value[a]))) continue;
        num = num + value[a];
        check++;
        if (check === checkuse) {
          check = 0;
          values.push(num);
        }
      }
    }
    let values2 = [];
    let valuesErrorFound = [];
    for (let a = 0; a < values.length; a++) {
      if (
        checkEmpty(values[a]) ||
        (checkEmpty(values[a]) && checkEmpty(values[a].trim()))
      )
        continue;
      if (
        values[a].indexOf("+") != -1 ||
        values[a].indexOf("x") != -1 ||
        values[a].indexOf("*") != -1
      ) {
        valuesErrorFound.push(values[a]);
        continue;
      }
      if (!checkEmpty(values[a]) && values[a].trim().length == checkuse) {
        values2.push(values[a].trim());
      }
    }
    let values3 = Object.assign([], values2);
    // for (let a = 0; a < values2.length; a++) {
    //   let n = values2[a];
    //   values3 = values3.concat(reverseString19(n));
    // }
    let checkuseReal = 1;
    let values4 = [];
    for (let a = 0; a < values3.length; a++) {
      if ((values3[a] + "").length == checkuseReal) {
        values4.push(values3[a]);
      }
    }

    let valuesFinal = numLot;
    valuesFinal = valuesFinal.concat(values4);
    let valueTemps = valuesFinal.filter((element, index) => {
      return valuesFinal.indexOf(element) === index;
    });

    setNumLot(Object.assign([], valueTemps));
    setNumLotError(valuesErrorFound);
    setValue_win("");
  };

  const setLot_2_3_advance = (type) => {
    console.log(type);
    let values = numLot;
    let values2 = Object.assign([], values);
    if (lotActive.key === "lot_2") {
      if (type === "double") {
        values2 = values2.concat([
          "11",
          "22",
          "33",
          "44",
          "55",
          "66",
          "77",
          "88",
          "99",
          "00",
        ]);
      } else if (type === "return") {
        for (let a = 0; a < values.length; a++) {
          let nreverse = reverseString2(values[a]);
          // let vs = nreverse.filter((element, index) => {
          //   return nreverse.indexOf(element) === index;
          // });
          // console.log("values2",Object.assign([],values2))
          // console.log("nreverse",nreverse)
          if (!checkEmpty(nreverse)) values2.push(nreverse);
        }
      } else if (type === "sister") {
        let str = "01 12 23 34 45 56 67 78 89 90";
        values2 = values2.concat(str.split(" "));
      }
    } else if (lotActive.key === "lot_3") {
      if (type === "double") {
        values2 = values2.concat([
          "111",
          "222",
          "333",
          "444",
          "555",
          "666",
          "777",
          "888",
          "999",
          "000",
        ]);
      } else if (type === "return") {
        let vss = [];
        for (let a = 0; a < values.length; a++) {
          let n = values[a];
          // values2 = values2.concat(reverseString3(n));
          let nreverse = reverseString3(values[a]);
          let vs = nreverse.filter((element, index) => {
            return nreverse.indexOf(element) === index;
          });
          // console.log("nreverse",nreverse)
          vss = vss.concat(vs);
        }
        values2 = vss;
      } else if (type === "double_back") {
        let str =
          "100 200 300 400 500 600 700 800 900 211 311 411 511 611 711 811 911 011 122 322 422 522 622 722 822 922 022 133 233 433 533 633 733 833 933 033 144 244 344 544 644 744 844 944 044 155 255 355 455 655 755 855 955 055 166 266 366 466 566 766 866 966 066 177 277 377 477 577 677 877 977 077 188 288 388 488 588 688 788 988 088 199 299 399 499 599 699 799 899 099";
        values2 = values2.concat(str.split(" "));
      } else if (type === "double_font") {
        let str =
          "001 002 003 004 005 006 007 008 009 112 113 114 115 116 117 118 119 110 221 223 224 225 226 227 228 229 220 331 332 334 335 336 337 338 339 330 441 442 443 445 446 447 448 449 440 551 552 553 554 556 557 558 559 550 661 662 663 664 665 667 668 669 660 771 772 773 774 775 776 778 779 770 881 882 883 884 885 886 887 889 880 991 992 993 994 995 996 997 998 990";
        values2 = values2.concat(str.split(" "));
      } else if (type === "font_back") {
        let str =
          "010 020 030 040 050 060 070 080 090 121 131 141 151 161 171 181 191 101 212 232 242 252 262 272 282 292 202 313 323 343 353 363 373 383 393 303 414 424 434 454 464 474 484 494 404 515 525 535 545 565 575 585 595 505 616 626 636 646 656 676 686 696 606 717 727 737 747 757 767 787 797 707 818 828 838 848 858 868 878 898 808 919 929 939 949 959 969 979 989 909";
        values2 = values2.concat(str.split(" "));
      }
    }
    console.log("values2", values2);
    let valuesFinal = [];
    valuesFinal = valuesFinal.concat(values2);
    let valueTemps = valuesFinal;

    setNumLot(Object.assign([], valueTemps));
  };

  const showCancelConfirm = (type) => {
    if (!checkEmpty(type)) setLotActive(type);
    setNumLot([]);
    setNumLotError([]);
    setBottomPriceMain("");
    setTopPriceMain("");
    setTotPriceMain("");
    setValue_2_3("");
    setValue_6("");
    setValue_19("");
    setValue_win("");
    setWinNumbers([]);
    setValue_19_nums(Object.assign([], []));
    setValue_6_nums(Object.assign([], []));
    setWinType1("win_2");
    setWinType2("win_not_double");
    // setLotBils([])
    // confirm({
    //   title: "ล้างข้อมูล",
    //   icon: <ExclamationCircleFilled />,
    //   content:
    //     "ข้อมูลที่ยังไม่บันทึกจะหายไปทันที กรุณายืนยันที่จะเปลี่ยนอีกครั้ง",
    //   okText: "ยืนยัน",
    //   okType: "danger",
    //   cancelText: "ยกเลิก",
    //   onOk() {
    //     // console.log('OK');
    //     if (!checkEmpty(type)) setLotActive(type);
    //     setNumLot([]);
    //   },
    //   onCancel() {
    //     console.log("Cancel");
    //   },
    // });
  };

  const showCancelConfirmClear = () => {
    // confirm({
    //   title: "ล้างข้อมูล",
    //   icon: <ExclamationCircleFilled />,
    //   content:
    //     "ข้อมูลที่ยังไม่บันทึกจะหายไปทันที กรุณายืนยันที่จะเปลี่ยนอีกครั้ง",
    //   okText: "ยืนยัน",
    //   okType: "danger",
    //   cancelText: "ยกเลิก",
    //   onOk() {
    //     clearBil();
    //   },
    //   onCancel() {
    //     console.log("Cancel");
    //   },
    // });
    clearBil();
  };

  const addLotBil = async () => {
    if (numLot.length == 0) return;
    let topPrice = 0;
    let bottomPrice = 0;
    let totPrice = 0;
    if (checkEmpty(topPriceMain)) topPrice = 0;
    else topPrice = topPriceMain;
    if (checkEmpty(bottomPriceMain)) bottomPrice = 0;
    else bottomPrice = bottomPriceMain;
    if (checkEmpty(totPriceMain)) totPrice = 0;
    else totPrice = totPriceMain;
    if (topPrice == 0 && bottomPrice == 0 && totPrice == 0) return;
    let lotSubType = "";
    let lotSubTypeTH = "";

    let bil = {
      lotKey: lotActive?.key,
      lotText: lotActive.name,
      nums: numLot,
      lotSubType: lotSubType,
      lotSubTypeTH: lotSubTypeTH,
    };

    bil.lotActive = lotActive;
    if (lotActive?.key === "lot_2") {
      // console.log("userInfo", userInfo);
      // if (!checkEmpty(userInfo?.user?.multi_price)) {
      //   if (!checkEmpty(topPrice))
      //     topPrice = parseInt(topPrice) * parseInt(userInfo?.user?.multi_price);
      //   if (!checkEmpty(bottomPrice))
      //     bottomPrice =
      //       parseInt(bottomPrice) * parseInt(userInfo?.user?.multi_price);
      // }
      console.log("topPrice", topPrice);
      lotSubType = "lot_2";
      lotSubTypeTH = "2 ตัว";

      bil.topPrice = topPrice;
      bil.bottomPrice = bottomPrice;
    } else if (lotActive?.key === "lot_3") {
      lotSubType = "lot_3";
      lotSubTypeTH = "3 ตัว";
      bil.topPrice = topPrice;
      bil.bottomPrice = bottomPrice;
      bil.totPrice = totPrice;
    } else if (lotActive?.key === "lot_6") {
      lotSubType = "lot_3";
      lotSubTypeTH = "3 ตัว";
      bil.topPrice = topPrice;
      bil.bottomPrice = bottomPrice;
      bil.totPrice = totPrice;
      bil.value_6_nums = value_6_nums;
    } else if (lotActive?.key === "lot_19") {
      // if (!checkEmpty(userInfo?.user?.multi_price)) {
      //   if (!checkEmpty(topPrice))
      //     topPrice = parseInt(topPrice) * parseInt(userInfo?.user?.multi_price);
      //   if (!checkEmpty(bottomPrice))
      //     bottomPrice =
      //       parseInt(bottomPrice) * parseInt(userInfo?.user?.multi_price);
      // }
      lotSubType = "lot_2";
      lotSubTypeTH = "2 ตัว";
      bil.topPrice = topPrice;
      bil.bottomPrice = bottomPrice;
      bil.value_19_nums = value_19_nums;
    } else if (lotActive?.key === "lot_run") {
      lotSubType = "lot_run";
      lotSubTypeTH = "เลขวิ่ง";
      bil.runTopPrice = topPrice;
      bil.runBottomPrice = bottomPrice;
    } else if (lotActive?.key === "lot_win") {
      if (winType1 === "win_2") {
        // if (!checkEmpty(userInfo?.user?.multi_price)) {
        //   if (!checkEmpty(topPrice))
        //     topPrice =
        //       parseInt(topPrice) * parseInt(userInfo?.user?.multi_price);
        //   if (!checkEmpty(bottomPrice))
        //     bottomPrice =
        //       parseInt(bottomPrice) * parseInt(userInfo?.user?.multi_price);
        // }
        lotSubType = "lot_2";
        lotSubTypeTH = "2 ตัว";
        bil.topPrice = topPrice;
        bil.bottomPrice = bottomPrice;
        bil.totPrice = totPrice;
      } else if (winType1 === "win_3") {
        lotSubType = "lot_3";
        lotSubTypeTH = "3 ตัว";
        bil.topPrice = topPrice;
        bil.bottomPrice = bottomPrice;
        bil.totPrice = totPrice;
      }
    }
    bil.lotSubType = lotSubType;
    bil.lotSubTypeTH = lotSubTypeTH;

    let doneAllClose = false;
    let closeOb;
    let checkCloseNum = true;
    if (checkCloseNum) {
      closeOb = checkCloseNumFn(bil, lotClosees);
      // console.log("closeOb", closeOb);
    }
    doneAllClose = closeOb.doneAll;

    if (!doneAllClose) {
      setNumLotErrorBilClose(closeOb.numberErrors);
      setConfirmnextModalClose(true);
      setcurrentBil(bil);
      return;
    }

    let doneAll = false;
    let prevent;
    try {
      prevent = await getCheckPreventV2(lotDate, lot, bil, lotPreventLot,lotBils);
    } catch (e) {
      logoutApi();
      clearToken();
      navigate(pathRoutes.login + "?session=false");
      return;
    }

    doneAll = prevent.doneAll;
    // console.log("bill",bil)

    // doneAll = true;
    if (doneAll) {
      setBottomPriceMain("");
      setTopPriceMain("");
      setTotPriceMain("");
      let bils = lotBils;
      // let cntBilNum = 0;
      // let cntBilNumArray = [];
      // for (let a = 0; a < bil.nums.length; a++) {
      //   if (!cntBilNumArray.includes(bil.nums[a])) {
      //     cntBilNumArray.push(bil.nums[a]);
      //     cntBilNum++;
      //   }
      // }
      // bil.cntBilNum = cntBilNum;
      bils.push(bil);
      console.log("bils", bils);
      setLotBils(Object.assign([], bils));
      setNumLot([]);
      setNumLotError([]);
      setWinNumbers([]);
      setNumLotErrorBil([]);
      setcurrentBil({});
      setValue_19_nums([]);
      setValue_6_nums([]);
    } else {
      setConfirmnextModal(true);
      setNumLotErrorBil(prevent.numberErrors);
      setcurrentBil(bil);
    }
  };

  const addLotBilAny = () => {
    let bil = currentBil;
    let nums = bil.nums;
    let numsFinal = [];
    for (let a = 0; a < nums.length; a++) {
      if (!numLotErrorBil.includes(nums[a])) {
        numsFinal.push(nums[a]);
      }
    }
    bil.nums = numsFinal;
    setBottomPriceMain("");
    setTopPriceMain("");
    setTotPriceMain("");
    let bils = lotBils;
    if (bil.nums.length > 0) {
      bils.push(bil);
    }
    console.log("bils", bils);
    setLotBils(Object.assign([], bils));
    setNumLot([]);
    setNumLotError([]);
    setWinNumbers([]);
    setNumLotErrorBil([]);
    setcurrentBil({});
    setValue_19_nums([]);
    setValue_6_nums([]);
  };

  const addLotBilAnyClose = () => {
    let bil = currentBil;
    let nums = bil.nums;
    let numsFinal = [];
    for (let a = 0; a < nums.length; a++) {
      if (!numLotErrorBilClose.includes(nums[a])) {
        numsFinal.push(nums[a]);
      }
    }
    bil.nums = numsFinal;
    setBottomPriceMain("");
    setTopPriceMain("");
    setTotPriceMain("");
    let bils = lotBils;
    if (bil.nums.length > 0) {
      bils.push(bil);
    }
    console.log("bils", bils);
    setLotBils(Object.assign([], bils));
    setNumLot([]);
    setNumLotError([]);
    setWinNumbers([]);
    setNumLotErrorBilClose([]);
    setcurrentBil({});
    setValue_19_nums([]);
    setValue_6_nums([]);
  };

  const getTexBil = (bil) => {
    let text1 = "";
    let text2 = "";
    let text3 = bil.topPrice;
    let text4 = bil.bottomPrice;
    let text5 = "";
    let text6 = "";
    let text0 = bil.lotText;
    if (bil.lotKey === "lot_2") {
      text1 = "บน";
      text2 = "ล่าง";
    } else if (bil.lotKey === "lot_3") {
      text1 = "บน";
      text2 = "โต๊ด";
      text4 = bil.totPrice;
    } else if (bil.lotKey === "lot_6") {
      text1 = "บน";
      text2 = "ล่าง";
      text0 = "3 ตัว";
    } else if (bil.lotKey === "lot_19") {
      text1 = "บน";
      text2 = "ล่าง";
      text0 = "2 ตัว";
    } else if (bil.lotKey === "lot_run") {
      text1 = "บน";
      text2 = "ล่าง";
      text0 = "เลขวิ่ง";
      text3 = bil.runTopPrice;
      text4 = bil.runBottomPrice;
    } else if (bil.lotKey === "lot_win") {
      text1 = "บน";
      text2 = "ล่าง";
      text4 = bil.bottomPrice;
      text6 = " x " + bil.totPrice;
      text5 = " x โต๊ด";
      text0 = "วินเลข";
    }

    if (bil.lotSubType == "lot_2") {
      if (!checkEmpty(userInfo?.user?.multi_price)) {
        text3 = parseInt(text3) * parseInt(userInfo?.user?.multi_price);
        text4 = parseInt(text4) * parseInt(userInfo?.user?.multi_price);
      }
    }

    return (
      <div>
        <div>{text0}</div>
        <div>{text1 + " x " + text2 + text5}</div>
        <div>{text3 + " x " + text4 + text6}</div>
      </div>
    );
  };

  const deleteBil = (index) => {
    let bils = lotBils;
    bils.splice(index, 1);
    setLotBils(Object.assign([], bils));
  };

  const editBil = (index) => {
    let billEdit = lotBils[index];
    let bils = lotBils;
    bils.splice(index, 1);
    setLotBils(Object.assign([], bils));

    let bottomPrice = billEdit.bottomPrice;
    let topPrice = billEdit.topPrice;
    if (billEdit.lotSubType == "lot_2") {
      // if (!checkEmpty(userInfo?.user?.multi_price)) {
      //   bottomPrice = parseInt(billEdit.bottomPrice) /  parseInt(userInfo?.user?.multi_price);
      //   topPrice = parseInt(billEdit.topPrice) /  parseInt(userInfo?.user?.multi_price);
      // }
    }

    console.log("billEdit", billEdit);
    setBottomPriceMain(bottomPrice);
    setTopPriceMain(topPrice);
    setTotPriceMain(billEdit.totPrice);
    setNumLot(Object.assign([], billEdit.nums));
    setLotActive(billEdit.lotActive);
    if (billEdit?.lotActive?.key === "lot_run") {
      setBottomPriceMain(billEdit.runBottomPrice);
      setTopPriceMain(billEdit.runTopPrice);
    } else if (billEdit?.lotActive?.key === "lot_19") {
      setValue_19_nums(billEdit.value_19_nums);
    } else if (billEdit?.lotActive?.key === "lot_6") {
      setValue_6_nums(billEdit.value_6_nums);
    }
  };

  const clearBil = () => {
    setLotBils(Object.assign([], []));
  };

  const saveBil = async () => {
    // console.log("totalNumsLot2More:", totalNumsLot2More);

    let lotTemp = Object.assign({}, lot);
    if (totalNumsLot2More && !(lot.lot_id == "51")) {
      lotTemp.pay_2 = "95";
    }
    if (lotActive52 != "52") {
      lotTemp.lot_id = lotActive52;
    }
    // console.log("lotTemp:", lotTemp);
    let body = {
      lot: lotTemp,
      detail: lotBils,
      remark: remark,
      lot_date: lotDate,
    };
    try {
      setLoadingSave(true);
      await saveBilApi(body);
      setLotBils([]);
      setRemark("");
      setLoadingSave(false);
      openNotificationWithIcon("success", "ลงหวย", "ลงหวยชุดนี้สำเร็จ");
      appContext.setTiggerLotTableBill5(appContext.tiggerLotTableBill5 + 1);
    } catch (e) {
      setLoadingSave(false);
      openNotificationWithIcon("error", "ลงหวย", "ลงหวยชุดนี้ไม่สำเร็จ");
    }
  };

  const [modal, contextHolder] = Modal.useModal();

  const showSaveConfirm = () => {
    const config = {
      title: "ลงหวย",
      content: <>หมดเวลาลงหวย</>,
    };
    // modal.error(config);
    let l = getAboteOpenUtil(lot);
    if (l?.status == false) {
      modal.error(config);
      return;
    }

    if (lotBils.length == 0 || remark.length == 0) {
      const config = {
        title: "ลงหวย",
        content: <>ใส่ข้อมูลไม่ครบ</>,
      };
      modal.error(config);
      return;
    }

    saveBil();
    // confirm({
    //   title: "บันทึก",
    //   icon: <QuestionOutlined />,
    //   content: "ยืนยันบันทึกบิลนี้",
    //   okText: "ยืนยัน",
    //   // okType: 'danger',
    //   cancelText: "ยกเลิก",
    //   onOk() {
    //     console.log("OK");
    //     saveBil();
    //   },
    //   onCancel() {
    //     console.log("Cancel");
    //   },
    // });
  };

  const calWinNumber = () => {
    if (winNumbers.length < 2) return;
    let values = [];
    if (winType1 === "win_2") {
      // let nloop = [];
      for (let a = 0; a < winNumbers.length; a++) {
        // nloop.push(a);
        for (let b = 0; b < winNumbers.length; b++) {
          if (!(b >= a)) continue;
          let v = "";
          if ("win_not_double" === winType2) {
            if (winNumbers[a] != winNumbers[b]) {
              v = winNumbers[a] + "" + winNumbers[b];
            }
          } else if ("win_double" === winType2) {
            v = winNumbers[a] + "" + winNumbers[b];
          }
          if (!checkEmpty(v)) values.push(v);
        }
      }
    } else if (winType1 === "win_3") {
      // let nloopA = [];
      let nloopB = [];
      // let nloop = [];
      for (let a = 0; a < winNumbers.length; a++) {
        // nloopA.push(a);
        for (let b = 0; b < winNumbers.length; b++) {
          // nloopB.push(b);
          if (!(b >= a)) continue;
          for (let c = 0; c < winNumbers.length; c++) {
            if (!(c >= a && c >= b && b >= a)) continue;
            let v = "";
            if ("win_double" === winType2) {
              v = winNumbers[a] + "" + winNumbers[b] + "" + winNumbers[c];
            } else if ("win_not_double" === winType2) {
              if (
                winNumbers[a] != winNumbers[b] &&
                winNumbers[b] != winNumbers[c] &&
                winNumbers[a] != winNumbers[c]
              ) {
                v = winNumbers[a] + "" + winNumbers[b] + "" + winNumbers[c];
              }
            }
            if (!checkEmpty(v)) values.push(v);
          }
        }
      }
    }

    let valuesFinal = numLot;
    valuesFinal = valuesFinal.concat(values);
    let valueTemps = valuesFinal.filter((element, index) => {
      return valuesFinal.indexOf(element) === index;
    });
    setNumLot(Object.assign([], valueTemps));
  };

  const reverseWinNumber = () => {
    if (numLot.length == 0) return;
    let values = numLot;
    let values2 = [];
    if (winType1 === "win_2") {
      for (let a = 0; a < values.length; a++) {
        let nreverse = reverseString2(values[a]);
        if (!checkEmpty(nreverse)) values2.push(nreverse);
      }
    } else if (winType1 === "win_3") {
      for (let a = 0; a < values.length; a++) {
        let n = values[a];
        values2 = values2.concat(reverseString3(n));
      }
    }

    let valuesFinal = numLot;
    valuesFinal = valuesFinal.concat(values2);
    let valueTemps = valuesFinal.filter((element, index) => {
      return valuesFinal.indexOf(element) === index;
    });

    setNumLot(Object.assign([], valueTemps));
  };

  const checkOpen = () => {
    setOpen(getAboteOpenUtil(lot)?.status);
  };

  const getTimeDown = useMemo(() => {
    let time = getAboteOpenUtil(lot)?.time;
    if (time == 0 || checkEmpty(time)) return;
    return (
      <Countdown
        date={Date.now() + time}
        onComplete={() => {
          console.log("check again");
          // checkOpen()
          setOpen(false);
        }}
      />
    );
  }, [lot]);

  useEffect(() => {
    checkOpen();
  }, [lot]);

  const totalPrice = useMemo(() => {
    let total = 0;
    for (let a = 0; a < lotBils.length; a++) {
      let lotOb = lotBils[a];
      for (let b = 0; b < lotOb.nums.length; b++) {
        let topPrice = lotOb.topPrice;
        let bottomPrice = lotOb.bottomPrice;
        if (lotOb.lotSubType == "lot_2") {
          if (!checkEmpty(userInfo?.user?.multi_price)) {
            bottomPrice =
              parseInt(lotOb.bottomPrice) *
              parseInt(userInfo?.user?.multi_price);
            topPrice =
              parseInt(lotOb.topPrice) * parseInt(userInfo?.user?.multi_price);
          }
        }
        // let num = lotOb.nums[b];
        if (lotOb.topPrice > 0) {
          total += parseInt(topPrice);
        }
        if (lotOb.bottomPrice > 0) {
          total += parseInt(bottomPrice);
        }
        if (lotOb.totPrice > 0) {
          total += parseInt(lotOb.totPrice);
        }
        if (lotOb.runTopPrice > 0) {
          total += parseInt(lotOb.runTopPrice);
        }
        if (lotOb.runBottomPrice > 0) {
          total += parseInt(lotOb.runBottomPrice);
        }
      }
    }
    return numberWithCommas(total);
  }, [lotBils]);

  const [api, contextHolderDone] = notification.useNotification();

  const openNotificationWithIcon = (type, title, message) => {
    api[type]({
      message: title,
      description: message,
    });
  };

  useEffect(() => {
    if (lotActive.key === "lot_2") {
      value_2_3_ref.current.focus();
      value_2_3_ref.current.setSelectionRange(0, 0);
    } else if (lotActive.key === "lot_3") {
      value_2_3_ref.current.focus();
      value_2_3_ref.current.setSelectionRange(0, 0);
    } else if (lotActive.key === "lot_6") {
      value_6_ref.current.focus();
      value_6_ref.current.setSelectionRange(0, 0);
    } else if (lotActive.key === "lot_19") {
      value_19_ref.current.focus();
      value_19_ref.current.setSelectionRange(0, 0);
    } else if (lotActive.key === "lot_run") {
      value_win_ref.current.focus();
      value_win_ref.current.setSelectionRange(0, 0);
    } else if (lotActive.key === "lot_win") {
      value_win_ref.current.focus();
      value_win_ref.current.setSelectionRange(0, 0);
    }
  }, [lotActive]);

  const getCntLotBils = (lotBils) => {};

  let cntBilNumTop = 0;
  let cntBilNumArrayTop = [];
  let cntBilNumBottom = 0;
  let cntBilNumArrayBttom = [];
  const getTotalNumBil = useMemo(() => {
    let ignore = false;
    if (ignore) {
      return <></>;
    }

    for (let z = 0; z < lotBils.length; z++) {
      let bil = lotBils[z];
      for (let a = 0; a < bil.nums.length; a++) {
        if (
          !cntBilNumArrayTop.includes(bil.nums[a]) &&
          bil.nums[a].length == 2
        ) {
          if (!checkEmpty(bil.topPrice) && parseInt(bil.topPrice) > 0) {
            cntBilNumArrayTop.push(bil.nums[a]);
            cntBilNumTop++;
          }
        }
        if (
          !cntBilNumArrayBttom.includes(bil.nums[a]) &&
          bil.nums[a].length == 2
        ) {
          if (!checkEmpty(bil.bottomPrice) && parseInt(bil.bottomPrice) > 0) {
            cntBilNumArrayBttom.push(bil.nums[a]);
            cntBilNumBottom++;
          }
        }
      }
    }
    console.log("cntBilNumTop", cntBilNumTop);
    console.log("cntBilNumBottom", cntBilNumBottom);
    let all2Div = <></>;
    if (cntBilNumTop > 60 && cntBilNumBottom > 60) {
      all2Div = (
        <div style={{ color: "red" }}>
          มีเลข 2 ตัวบนและล่างจำนวนเกิน 60 ตัว
          {/* {" " + numberWithCommas(cntBilNumTop + cntBilNumBottom) + " "}ตัว */}
        </div>
      );
    }
    let all2Top = <></>;
    if (cntBilNumTop > 60) {
      all2Top = (
        <div style={{ color: "red" }}>
          มีเลข 2 ตัวบนจำนวนเกิน 60 ตัว
          {/* {" " + numberWithCommas(cntBilNumTop) + " "}ตัว */}
        </div>
      );
    }
    let all2ฺBottom = <></>;
    if (cntBilNumBottom > 60) {
      all2ฺBottom = (
        <div style={{ color: "red" }}>
          มีเลข 2 ตัวล่างจำนวนเกิน 60 ตัว
          {/* {" " + numberWithCommas(cntBilNumBottom) + " "}ตัว */}
        </div>
      );
    }

    setTotalNumsLot2More(false);
    if (cntBilNumTop > 60 && cntBilNumBottom <= 60) {
      setTotalNumsLot2More(true);
      return <>{all2Top}</>;
    } else if (cntBilNumTop <= 60 && cntBilNumBottom > 60) {
      setTotalNumsLot2More(true);
      return <>{all2ฺBottom}</>;
    } else if (cntBilNumTop > 60 && cntBilNumBottom > 60) {
      setTotalNumsLot2More(true);
      return <>{all2Div}</>;
    }
  }, [lotBils]);

  const columnPrevents = [
    {
      title: "เลข",
      dataIndex: "num",
      key: "num",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { num }) => (
        <>
          <span style={{ color: "green", fontWeight: num.fontWeight }}>
            {num.text}
          </span>
        </>
      ),
    },
    {
      title: "จ่ายราคา",
      dataIndex: "price",
      key: "price",
      // render: (text) => <span style={{ color: "blue" }}>{text}</span>,
      render: (_, { price }) => (
        <>
          <span style={{ color: "blue", fontWeight: price.fontWeight }}>
            {price.text}
          </span>
        </>
      ),
    },
    {
      title: "ชนิดหวย",
      key: "type",
      dataIndex: "type",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { type }) => (
        <>
          <span style={{ color: "green", fontWeight: type.fontWeight }}>
            {getTextType(type.text)}
          </span>
        </>
      ),
    },
    ,
  ];

  const reflectorLotPrevent = (datatemp) => {
    let datas = [];
    for (let a = 0; a < datatemp?.length; a++) {
      let object = datatemp[a];
      let num = object.prevent_number;
      let type = object.prevent_number_type;
      let price = object.price;
      let data = {
        num: {
          text: num,
          fontWeight: "bold",
        },
        price: { text: price, fontWeight: "bold" },
        type: { text: type, fontWeight: "bold" },
      };
      datas.push(data);
    }
    setLotPrevent(Object.assign([], datas));
  };

  const getNumBill = (bil, nlot) => {
    let type = "";
    if (bil.topPrice > 0) {
      if (bil.lotSubType == "lot_2") {
        type = "lot_2";
      } else if (bil.lotSubType == "lot_3") {
        type = "lot_3_top";
      }
    }
    if (bil.bottomPrice > 0) {
      type = "lot_2";
    }
    if (bil.totPrice > 0) {
      type = "lot_3_tot";
    }
    let preventNum = getPrevent(lot.prevent_numbers, nlot, type);
    let prevent = false;
    if (!checkEmpty(preventNum)) prevent = true;
    return (
      <div
        className={
          prevent ? styles.billBoxItemFinalPrevent : styles.billBoxItemFinal
        }
      >
        {nlot}
      </div>
    );
  };

  const [loadingColor, setLoadingColor] = useState(false);
  const saveColor = async () => {
    if (checkEmpty(bgColorTemp)) return;
    let body = {
      color: bgColor,
    };
    try {
      setLoadingColor(true);
      await savePostUtilApi("save-color", body);
      setLoadingColor(false);
      openNotificationWithIcon(
        "success",
        "สีพื้นหลัง",
        "บันทึกสีพื้นหลังสำเร็จ"
      );
      localStorage.setItem(AuthKeys.cardBgColor, bgColor);
      // setBgColorTemp(bgColor);
    } catch (e) {
      setLoadingColor(false);
      openNotificationWithIcon(
        "success",
        "สีพื้นหลัง",
        "บันทึกสีพื้นหลังไม่สำเร็จ"
      );
    }
  };

  return (
    <>
      <div className={styles.box100}>
        <div className={styles.selectcolor}>
          <Popover
            placement="bottom"
            title={"สีพื้นหลัง"}
            content={
              <div className={styles.selectcolorbody}>
                <HexColorPicker
                  color={bgColor}
                  onChange={(color) => {
                    // console.log("color", color);
                    // setBgColorTemp(color);
                    setBgColor(color);
                  }}
                />
                <div style={{ paddingTop: "15px", display: "flex" }}>
                  <div>
                    <Button
                      // className={styles.btnSearchSum}
                      type="primary"
                      onClick={() => {
                        if (loadingColor) return;
                        saveColor();
                      }}
                    >
                      {loadingColor ? <LoadingCenterSpinSmallBlue /> : "บันทึก"}
                    </Button>
                  </div>
                  <div style={{ paddingLeft: "15px" }}>
                    <Button
                      // className={styles.btnSearchSum}
                      // type="primary"
                      onClick={() => {
                        setBgColor(bgColorTemp);
                      }}
                    >
                      {"ยกเลิก"}
                    </Button>
                  </div>
                </div>
              </div>
            }
            trigger="click"
          >
            <Button>สีพื้นหลัง</Button>
          </Popover>
        </div>

        <div className={styles.backBtn}>
          <div
            className={styles.backBtnIn}
            onClick={() => {
              navigate(pathRoutes.main);
            }}
          >
            {"< "}ย้อนกลับ
          </div>
        </div>

        {/* <div style={{ display: "flex" }}> */}
        <div className={styles.gridgapbox}>
          <div className={styles.boxFnLot}>
            <div style={{ textAlign: "-webkit-center" }}>
              {open ? (
                <div style={{ padding: "20px", color: "red" }}>
                  ปิดใน {getTimeDown}
                </div>
              ) : (
                <div style={{ padding: "20px", color: "red" }}>
                  {"ปิด (" +
                    (checkEmpty(lot.lot_time_close) ? "" : lot.lot_time_close) +
                    ")"}
                </div>
              )}

              <Card
                // style={{ width: 240 }}
                headStyle={{ color: "black" }}
                hoverable
                // onClick={onclick}
                className={[styles.cardLotMainS1].join(" ")}
                bordered={false}
                style={{ width: "100%", backgroundColor: bgColor }}
              >
                <div className={styles.detailCard}>
                  <div className={styles.detailCardIn}>
                    <div>
                      {lot.lot_id != "52"
                        ? "[" +
                          (checkEmpty(lot.lot_type) ? "" : lot.lot_type) +
                          "]"
                        : ""}
                    </div>
                    <div style={{ paddingLeft: "10px" }}>
                      {lot.lot_id != "52"
                        ? checkEmpty(lot.lot_name)
                          ? ""
                          : lot.lot_name
                        : ""}
                    </div>
                  </div>
                  <div>{currentLotDate}</div>
                </div>
                <div className={styles.boxTypeLot}>
                  {lotTypes.map((lottype) => {
                    return (
                      <div
                        className={
                          lotActive?.key == lottype.key
                            ? styles.boxTypeLotItemActive
                            : styles.boxTypeLotItem
                        }
                        onClick={() => {
                          showCancelConfirm(lottype);
                          // if (numLot.length > 0) {
                          //   showCancelConfirm(lottype);
                          // } else {
                          //   setLotActive(lottype);
                          // }
                        }}
                      >
                        {lottype.name}
                      </div>
                    );
                  })}
                </div>
                <div>
                  <div className={styles.billBoxErr}>
                    {numLotError.map((nlot, index) => {
                      return (
                        <div
                          className={styles.billBoxItemError}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            let nums = numLotError;
                            nums.splice(index, 1);
                            setNumLotError(Object.assign([], nums));
                          }}
                        >
                          {nlot}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className={styles.detailCard}>
                  <div className={styles.billBox}>
                    {numLot.map((nlot, index) => {
                      return (
                        <div
                          className={styles.billBoxItem}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            let nums = numLot;
                            nums.splice(index, 1);
                            setNumLot(Object.assign([], nums));
                          }}
                        >
                          {nlot}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    <Button
                      type="primary"
                      danger
                      onClick={() => {
                        showCancelConfirm();
                      }}
                    >
                      ยกเลิก
                    </Button>
                  </div>
                </div>

                {(lotActive.key === "lot_2" || lotActive.key === "lot_3") && (
                  <>
                    <div style={{ display: "flex" }} className={styles.btnFn23}>
                      <div>
                        <Button
                          type="primary"
                          onClick={() => {
                            setLot_2_3_advance("double");
                          }}
                        >
                          {lotActive.text1}
                        </Button>
                      </div>
                      {lotActive.key === "lot_2" && (
                        <div style={{ paddingLeft: "10px" }}>
                          <Button
                            type="primary"
                            onClick={() => {
                              setLot_2_3_advance("sister");
                            }}
                          >
                            + เลขพี่น้อง
                          </Button>
                        </div>
                      )}
                      {lotActive.key === "lot_3" && (
                        <>
                          <div style={{ paddingLeft: "10px" }}>
                            <Button
                              type="primary"
                              onClick={() => {
                                setLot_2_3_advance("double_font");
                              }}
                            >
                              + เบิ้ลหน้า
                            </Button>
                          </div>
                          <div style={{ paddingLeft: "10px" }}>
                            <Button
                              type="primary"
                              onClick={() => {
                                setLot_2_3_advance("double_back");
                              }}
                            >
                              + เบิ้ลหลัง
                            </Button>
                          </div>
                          <div style={{ paddingLeft: "10px" }}>
                            <Button
                              type="primary"
                              onClick={() => {
                                setLot_2_3_advance("font_back");
                              }}
                            >
                              + เลขหาม
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                    <div
                      className={styles.detailCard}
                      style={{ paddingTop: "10px" }}
                    >
                      <div>
                        <Input
                          placeholder="ใส่เลข"
                          onKeyDown={setLot_2_3}
                          onChange={setLot_2_3}
                          value={value_2_3}
                          ref={value_2_3_ref}
                        />
                      </div>
                      <div>
                        <Button
                          type="primary"
                          onClick={() => {
                            setLot_2_3_advance("return");
                          }}
                        >
                          กลับเลข
                        </Button>
                      </div>
                      <div>
                        <Input
                          type="number"
                          placeholder={lotActive.text2}
                          value={topPriceMain}
                          onChange={(e) => {
                            setTopPriceMain(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              value_bt_23_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              value_bt_23_ref.current.focus();
                              return;
                            }
                            setTopPriceMain(e.target.value);
                          }}
                          ref={value_top_23_ref}
                          onWheel={(e) => {
                            e.target.blur();
                            e.stopPropagation();
                          }}
                        />
                      </div>
                      <div>
                        <Input
                          type="number"
                          ref={value_bt_23_ref}
                          placeholder={lotActive.text3}
                          value={
                            lotActive.key === "lot_3"
                              ? totPriceMain
                              : bottomPriceMain
                          }
                          onChange={(e) => {
                            if (lotActive.key === "lot_3") {
                              setTotPriceMain(e.target.value);
                            } else {
                              setBottomPriceMain(e.target.value);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              btn_add_23_ref.current.click();
                              value_2_3_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              btn_add_23_ref.current.click();
                              value_2_3_ref.current.focus();
                              return;
                            }
                            if (lotActive.key === "lot_3") {
                              setTotPriceMain(e.target.value);
                            } else {
                              setBottomPriceMain(e.target.value);
                            }
                          }}
                          onWheel={(e) => {
                            e.target.blur();
                            e.stopPropagation();
                          }}
                        />
                      </div>
                      <div>
                        <Button onClick={addLotBil} ref={btn_add_23_ref}>
                          +เพิ่มบิล
                        </Button>
                      </div>
                    </div>
                  </>
                )}

                {lotActive.key === "lot_6" && (
                  <>
                    <div
                      className={styles.detailCard}
                      style={{ paddingTop: "10px" }}
                    >
                      <div>
                        <Input
                          placeholder="ใส่เลข"
                          onKeyDown={setLot_6}
                          onChange={setLot_6}
                          value={value_6}
                          ref={value_6_ref}
                        />
                      </div>

                      <div>
                        <Input
                          type="number"
                          placeholder={"บน"}
                          value={topPriceMain}
                          onChange={(e) => {
                            setTopPriceMain(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              btn_add_6_ref.current.click();
                              value_6_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              btn_add_6_ref.current.click();
                              value_6_ref.current.focus();
                              return;
                            }
                            setTopPriceMain(e.target.value);
                          }}
                          ref={value_top_6_ref}
                          onWheel={(e) => {
                            e.target.blur();
                            e.stopPropagation();
                          }}
                        />
                      </div>

                      <div>
                        <Button onClick={addLotBil} ref={btn_add_6_ref}>
                          +เพิ่มบิล
                        </Button>
                      </div>
                    </div>
                  </>
                )}
                {lotActive.key === "lot_19" && (
                  <>
                    <div
                      className={styles.detailCard}
                      style={{ paddingTop: "10px" }}
                    >
                      <div>
                        <Input
                          placeholder="ใส่เลข"
                          onKeyDown={setLot_19}
                          onChange={setLot_19}
                          value={value_19}
                          ref={value_19_ref}
                        />
                      </div>

                      <div>
                        <Input
                          type="number"
                          placeholder={lotActive.text1}
                          value={topPriceMain}
                          onChange={(e) => {
                            setTopPriceMain(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              value_bt_19_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              value_bt_19_ref.current.focus();
                              return;
                            }
                            setTopPriceMain(e.target.value);
                          }}
                          ref={value_top_19_ref}
                          onWheel={(e) => {
                            e.target.blur();
                            e.stopPropagation();
                          }}
                        />
                      </div>
                      <div>
                        <Input
                          type="number"
                          placeholder={lotActive.text2}
                          value={bottomPriceMain}
                          onChange={(e) => {
                            setBottomPriceMain(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              btn_add_19_ref.current.click();
                              value_19_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              btn_add_19_ref.current.click();
                              value_19_ref.current.focus();
                              return;
                            }
                            setBottomPriceMain(e.target.value);
                          }}
                          ref={value_bt_19_ref}
                          onWheel={(e) => {
                            e.target.blur();
                            e.stopPropagation();
                          }}
                        />
                      </div>

                      <div>
                        <Button onClick={addLotBil} ref={btn_add_19_ref}>
                          +เพิ่มบิล
                        </Button>
                      </div>
                    </div>
                  </>
                )}

                {lotActive.key === "lot_run" && (
                  <>
                    <div
                      className={styles.detailCard}
                      style={{ paddingTop: "10px" }}
                    >
                      <div>
                        <Input
                          placeholder="ใส่เลข"
                          onKeyDown={setLot_win}
                          onChange={setLot_win}
                          value={value_win}
                          ref={value_win_ref}
                        />
                      </div>

                      <div>
                        <Input
                          type="number"
                          placeholder={lotActive.text1}
                          value={topPriceMain}
                          onChange={(e) => {
                            setTopPriceMain(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              value_bt_run_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              value_bt_run_ref.current.focus();
                              return;
                            }
                            setTopPriceMain(e.target.value);
                          }}
                          ref={value_top_run_ref}
                          onWheel={(e) => {
                            e.target.blur();
                            e.stopPropagation();
                          }}
                        />
                      </div>
                      <div>
                        <Input
                          type="number"
                          placeholder={lotActive.text2}
                          value={bottomPriceMain}
                          onChange={(e) => {
                            setBottomPriceMain(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              btn_add_run_ref.current.click();
                              value_win_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              btn_add_run_ref.current.click();
                              value_win_ref.current.focus();
                              return;
                            }
                            setBottomPriceMain(e.target.value);
                          }}
                          ref={value_bt_run_ref}
                          onWheel={(e) => {
                            e.target.blur();
                            e.stopPropagation();
                          }}
                        />
                      </div>

                      <div>
                        <Button onClick={addLotBil} ref={btn_add_run_ref}>
                          +เพิ่มบิล
                        </Button>
                      </div>
                    </div>
                  </>
                )}

                {lotActive.key === "lot_win" && (
                  <>
                    <div
                      className={[
                        styles.detailCard,
                        styles.detailCardTypwin,
                        styles.radioM,
                      ].join(" ")}
                    >
                      <Radio.Group
                        onChange={(e) => {
                          setWinType1(e.target.value);
                          setNumLot([]);
                          // setWinNumbers([]);
                        }}
                        value={winType1}
                      >
                        <Radio value={"win_2"}>จับวิน 2 ตัว</Radio>
                        <Radio value={"win_3"}>จับวิน 3 ตัว</Radio>
                      </Radio.Group>
                    </div>
                    <div
                      className={[
                        styles.detailCard,
                        styles.detailCardTypwin,
                        styles.radioM,
                      ].join(" ")}
                    >
                      <Radio.Group
                        onChange={(e) => {
                          setWinType2(e.target.value);
                          setNumLot([]);
                          // setWinNumbers([]);
                        }}
                        value={winType2}
                      >
                        <Radio value={"win_not_double"}>
                          จับวินไม่รวมเลขเบิ้ล
                        </Radio>
                        <Radio value={"win_double"}>จับวินรวมเลขเบิ้ล</Radio>
                      </Radio.Group>
                    </div>
                    <div
                      style={{ textAlignLast: "start" }}
                      className={styles.textPhoneCenter}
                    >
                      กรุณาเลือกตัวเลขที่ต้องการจับวิน 2 - 7 ตัวเลข
                    </div>
                    {/* <div className={styles.detailCardNum}>
                  {[1, 2, 3, 4, 5].map((n) => {
                    return (
                      <div
                        className={
                          winNumbers.includes(n)
                            ? styles.itemWinNumActive
                            : styles.itemWinNum
                        }
                        onClick={() => {
                          addWinNums(n);
                        }}
                      >
                        {n}
                      </div>
                    );
                  })}
                </div> */}
                    {/* <div className={styles.detailCardNum}>
                  {[6, 7, 8, 9, 0].map((n) => {
                    return (
                      <div
                        className={
                          winNumbers.includes(n)
                            ? styles.itemWinNumActive
                            : styles.itemWinNum
                        }
                        onClick={() => {
                          addWinNums(n);
                        }}
                      >
                        {n}
                      </div>
                    );
                  })}
                </div> */}
                    <div className={styles.billBox}>
                      {winNumbers.map((nlot, index) => {
                        return (
                          <div
                            className={styles.billBoxItem}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              let nums = winNumbers;
                              nums.splice(index, 1);
                              setWinNumbers(Object.assign([], nums));
                            }}
                          >
                            {nlot}
                          </div>
                        );
                      })}
                    </div>
                    <div
                      className={styles.detailCard}
                      style={{ paddingTop: "10px" }}
                    >
                      <div>
                        <Input
                          placeholder={"ใส่เลข"}
                          value={winNumber}
                          ref={value_win_ref}
                          onChange={(e) => {
                            setWinNumberCal(e);
                            // setWinNumber(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              btn_cal_win_ref.current.click();
                              btn_cal_win_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              btn_cal_win_ref.current.click();
                              btn_cal_win_ref.current.focus();
                              return;
                            } else if (e.code == "Space") {
                              reverseWinNumber();
                              return;
                            }
                            setWinNumberCal(e);
                            // setWinNumber(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div
                      style={{ paddingTop: "10px", display: "flex" }}
                      className={styles.btnwinFN}
                    >
                      <div>
                        <Button
                          onClick={calWinNumber}
                          ref={btn_cal_win_ref}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              btn_cal_win_ref.current.click();
                              value_top_win_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              btn_cal_win_ref.current.click();
                              value_top_win_ref.current.focus();
                              return;
                            } else if (e.code == "Space") {
                              reverseWinNumber();
                              return;
                            }
                          }}
                        >
                          คำนวณ
                        </Button>
                      </div>
                      <div style={{ paddingLeft: "5px" }}>
                        <Button onClick={reverseWinNumber}>กลับเลขวิน</Button>
                      </div>
                    </div>
                    <div
                      className={styles.detailCard}
                      style={{ paddingTop: "10px" }}
                    >
                      <div>
                        <Input
                          type="number"
                          placeholder={"บน"}
                          value={topPriceMain}
                          onChange={(e) => {
                            setTopPriceMain(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              value_bt_win_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              value_bt_win_ref.current.focus();
                              return;
                            }
                            setTopPriceMain(e.target.value);
                          }}
                          ref={value_top_win_ref}
                          onWheel={(e) => {
                            e.target.blur();
                            e.stopPropagation();
                          }}
                        />
                      </div>
                      <div>
                        <Input
                          type="number"
                          placeholder={winType1 == "win_2" ? "ล่าง" : "โต๊ด"}
                          value={
                            winType1 == "win_2" ? bottomPriceMain : totPriceMain
                          }
                          onChange={(e) => {
                            if (winType1 == "win_2")
                              setBottomPriceMain(e.target.value);
                            else setTotPriceMain(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key == "Tab") {
                              e.preventDefault();
                              btn_add_win_ref.current.click();
                              value_win_ref.current.focus();
                              return;
                            } else if (e.key == "Enter") {
                              btn_add_win_ref.current.click();
                              value_win_ref.current.focus();
                              return;
                            }
                            if (winType1 == "win_2")
                              setBottomPriceMain(e.target.value);
                            else setTotPriceMain(e.target.value);
                          }}
                          ref={value_bt_win_ref}
                          onWheel={(e) => {
                            e.target.blur();
                            e.stopPropagation();
                          }}
                        />
                      </div>

                      <div>
                        <Button onClick={addLotBil} ref={btn_add_win_ref}>
                          +เพิ่มบิล
                        </Button>
                      </div>
                    </div>
                  </>
                )}

                <div style={{ paddingTop: "10px" }}>
                  {lotBils.map((bil, index) => {
                    return (
                      <div className={styles.mainboxbillitem}>
                        <div className={styles.bilItem}>
                          <div style={{ width: "110px" }}>
                            <div>{getTexBil(bil)}</div>
                          </div>
                          <div
                            className={
                              bil.lotSubType === "lot_3"
                                ? styles.billBoxFinal_3
                                : styles.billBoxFinal
                            }
                          >
                            {bil?.nums?.map((nlot) => {
                              return getNumBill(bil, nlot);
                            })}
                          </div>
                          {/* <div>{numberWithCommas(bil.cntBilNum)}</div> */}
                          <div className={styles.boxfnbill}>
                            <div>
                              <DeleteOutlined
                                style={{ fontSize: "18px" }}
                                onClick={() => {
                                  deleteBil(index);
                                }}
                              />
                            </div>
                            <div>
                              <FormOutlined
                                style={{ fontSize: "18px" }}
                                onClick={() => {
                                  editBil(index);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles.boxfnbillmobile}>
                          <div>
                            <DeleteOutlined
                              style={{ fontSize: "30px" }}
                              onClick={() => {
                                deleteBil(index);
                              }}
                            />
                          </div>
                          <div>
                            <FormOutlined
                              style={{ fontSize: "30px", paddingLeft: "15px" }}
                              onClick={() => {
                                editBil(index);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Card>

              <div>
                <div
                  style={{
                    paddingTop: "10px",
                    display: "flex",
                    placeContent: "center",
                    fontWeight: "bold",
                    fontSize: "22px",
                  }}
                >
                  {"รวม " + totalPrice + " บาท"}
                </div>
                <div
                  style={{
                    paddingTop: "10px",
                    display: "flex",
                    placeContent: "center",
                  }}
                >
                  {/* <div>หมายเหตุ :</div> */}
                  <div
                    style={{ width: "400px" }}
                    className={styles.inputParent}
                  >
                    <Input
                      placeholder={"หมายเหตุ"}
                      value={remark}
                      onChange={(e) => {
                        setRemark(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        setRemark(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    paddingTop: "10px",
                    display: "flex",
                    placeContent: "center",
                    fontWeight: "bold",
                    fontSize: "22px",
                  }}
                >
                  <div className={styles.boxNameAddbill}>
                    {lot.lot_id != "52" ? (
                      <div>
                        {"[" +
                          (checkEmpty(lot.lot_type) ? "" : lot.lot_type) +
                          "]" +
                          " " +
                          (checkEmpty(lot.lot_name) ? "" : lot.lot_name) +
                          " "}
                      </div>
                    ) : (
                      <div></div>
                    )}
                    <div className={styles.boxdateAddbill}>
                      {currentLotDate}
                    </div>
                  </div>
                </div>

                <div style={{ paddingTop: "15px" }}>{getTotalNumBil}</div>
                {lot?.lot_id == "52" && (
                  <div style={{ paddingLeft: "10px" }}>
                    <Select
                      placeholder={"เลือกหวย"}
                      style={{ width: "300px" }}
                      value={lotActive52}
                      defaultValue={"52"}
                      onChange={(v) => {
                        setLotActive52(v);
                      }}
                      options={lotActive52List}
                    />
                  </div>
                )}

                <div
                  style={{
                    padding: "20px",
                    display: "flex",
                    placeContent: "center",
                    paddingBottom: "50px",
                  }}
                  className={styles.btnParent}
                >
                  <div>
                    <Button
                      type="primary"
                      danger
                      onClick={showCancelConfirmClear}
                    >
                      ล้าง
                    </Button>
                  </div>
                  <div style={{ paddingLeft: "10px" }}>
                    <Button
                      type="primary"
                      onClick={() => {
                        if (loadingSave) return;
                        showSaveConfirm();
                      }}
                    >
                      {loadingSave ? <LoadingCenterSpinSmall /> : "บันทึก"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.box5Detail}>
            <div>
              <LotTableFnPage />
            </div>
            <div>
              <div>
                <div className={styles.headerCloseNum}>{"หวยปิดรับ 3 ตัว"}</div>
                <div className={styles.gridCloseNum}>
                  {lotClosees3.map((close) => {
                    return (
                      <div className={styles.close_num}>
                        {close.close_number}
                      </div>
                    );
                  })}
                  {lotClosees3.length == 0 && (
                    <div className={styles.textClose0}>(ไม่มี)</div>
                  )}
                </div>
                <div className={styles.headerCloseNum}>{"หวยปิดรับ 2 ตัว"}</div>
                <div className={styles.gridCloseNum}>
                  {lotClosees2
                    .filter((close) => close.close_number_type == "lot_2")
                    .map((close) => {
                      return (
                        <div className={styles.close_num}>
                          {close.close_number}
                        </div>
                      );
                    })}
                  {lotClosees2.length == 0 && (
                    <div className={styles.textClose0}>(ไม่มี)</div>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className={styles.headerCloseNum}>{"หวยอั้น"}</div>
              <Table
                className={styles.table}
                columns={columnPrevents}
                dataSource={lotPrevent}
                pagination={false}
                rowClassName={styles.rowClassRotResualtSet_buy}
              />
            </div>
          </div>
        </div>
      </div>
      {contextHolder}
      {contextHolderDone}
      <Modal
        title="เลขเต็ม"
        open={confirmnextModal}
        onOk={() => {
          setConfirmnextModal(false);
          addLotBilAny();
        }}
        onCancel={() => {
          setConfirmnextModal(false);
        }}
      >
        <div>เลขเต็มจำนวนที่รับได้ตามระบบ ไม่สามารถแทงได้</div>
        <div className={styles.boxerrnumberbil}>
          {numLotErrorBil.map((num) => {
            return <div className={styles.errnumberbil}>{num}</div>;
          })}
        </div>
        <div>ยืนยันที่จะลงเลขที่เหลือต่อไป</div>
      </Modal>

      <Modal
        title="หวยปิดรับ"
        open={confirmnextModalClose}
        onOk={() => {
          setConfirmnextModalClose(false);
          addLotBilAnyClose();
        }}
        onCancel={() => {
          setConfirmnextModalClose(false);
        }}
      >
        <div>หวยปิดรับ ไม่สามารถแทงได้</div>
        <div className={styles.boxerrnumberbil}>
          {numLotErrorBilClose.map((num) => {
            return <div className={styles.errnumberbil}>{num}</div>;
          })}
        </div>
        <div>ยืนยันที่จะลงเลขที่เหลือต่อไป</div>
      </Modal>

      <div style={{ paddingBottom: "50px" }} className={styles.backToTopDiv}>
        <Button
          onClick={() => {
            window.scrollTo(0, 0);
          }}
          className={styles.backToTop}
        >
          Back To Top
        </Button>
      </div>
    </>
  );
}

export default MainS1;
